/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { createTracker as createTrackerPublic } from 'usage-tracker-public';
import { UsageTracker } from './UsageTracker';
import { waitForGlobal } from './utils';
import Raven from 'raven-js';
export class UsageTrackerPublic extends UsageTracker {
  constructor() {
    super();
    this.queue = [];
    this.consent = {
      allowed: false,
      categories: {
        necessary: true,
        analytics: false,
        advertisement: false,
        functionality: false
      }
    };
    this.lastScreen = undefined;
    void this.waitForCookieBannerQueue(window);
  }
  get trackerCreator() {
    return createTrackerPublic;
  }
  waitForCookieBannerQueue(win) {
    return waitForGlobal(win, '_hsp').then(_hsp => {
      _hsp.push(['addPrivacyConsentListener', consent => {
        this.consent = consent;
        if (consent.allowed) {
          this.drainQueue();
        }
      }]);
    }).catch(error => {
      Raven.captureException(error);
    });
  }
  queueEvent(eventName, props, tracker) {
    this.queue.push({
      eventName,
      props,
      tracker
    });
  }
  drainQueue() {
    while (this.queue.length > 0) {
      const event = this.queue.shift();
      if (event) {
        const {
          eventName,
          props,
          tracker
        } = event;
        tracker.track(eventName, props);
      }
    }
  }
  shouldQueue() {
    return !this.consent.allowed;
  }
  _trackWithTracker(tracker, eventName, eventProps) {
    let props = eventProps;
    if (eventProps && eventProps.screen) {
      this.lastScreen = eventProps.screen;
    } else if (this.lastScreen) {
      props = Object.assign({}, eventProps, {
        screen: this.lastScreen
      });
    }
    if (this.shouldQueue()) {
      this.queueEvent(eventName, props, tracker);
    } else {
      tracker.track(eventName, props);
    }
  }
}
export default new UsageTrackerPublic();